import styled from "styled-components";

export const ProjectNameTitle = styled.span`
  font-size: 14px;
  line-height: 17px;
  font-weight: bold;
  color: ${(props) => props.color || "black"};
`;
